import { CompositeLayer, Position, UpdateParameters } from "@deck.gl/core"
import { BitmapLayer } from "@deck.gl/layers"
import { MapLayerImage } from "../types"
import { getGlobalTerrainData } from "features/map/GlobalTerrainManager"

export default class PDFRasterLayer extends CompositeLayer<MapLayerImage> {
    static layerName = "PDFRasterLayer"

    updateState({ props, changeFlags }: UpdateParameters<this>): void {
        if (changeFlags.dataChanged) {
            this.setState({ layers: (props.data || []) as MapLayerImage[] })
        }
    }

    renderLayers() {
        return (this.state.layers as MapLayerImage[])
            .filter((layer) => layer.isVisible)
            .map((layer) => {
                if (!layer.bbox || (!layer.imageData && !layer.imageSrc)) return
                return new BitmapLayer({
                    id: `pdf-raster-layer-${layer.flightId}`,
                    image: layer.imageData || layer.imageSrc, // imageSrc should only be used for the initial mocked object URL.
                    extensions: [...getGlobalTerrainData().extensions],
                    bounds: layer.bbox as [Position, Position, Position, Position],
                })
            })
    }
}
